<template>
  <div class="tradeTable">
    <el-table
      :data="trade"
      stripe
      :header-row-style="bg"
      style="width:100%"
    >
      <el-table-column
        prop="name"
        label="客户名称"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号码"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="客户标签"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createTIME"
        label="用餐时间"
        header-align="center"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['trade'],
  data () {
    return {
      bg: {
        'background-color': '#fafafa'
      },
      mchId: '',
      error: true,
      hidden: true,
      phone: ''
    }
  },
  mounted () {
    this.mchId = this.$store.getters.mchId
  },
  methods: {
    tofixed (row, column, cellValue) {
      return toFloat(cellValue)
    },
    refundFormat (val) {
      let str = '';
      switch (val) {
        case 1:
          str = '园区支付';
          break
        case 2:
          str = '微信';
          break
        case 3:
          str = '支付宝';
          break
        case 4:
          str = '--';
          break
      }
      return str
    },
    closeSuc () {
      this.refundSuccess = false
    },
    assignment (amount) {
      this.inputVal = amount
    },
    submit () {
      let money = this.inputVal;
      if(money === '' || money === null) {
        this.$message({
          message: '退款金额不能为空，请重新输入'
        });
        
      } else {
        let newMoney = Number(this.inputVal);
        if(this.isMoney (newMoney)){
          if(Number(this.inputVal) > Number(this.refundDetail.amount)) {
            this.error = false;
            setTimeout(() => {
              this.error = true;
            },3000);
            return;
          } 
          // let data = this.refundDetail;
          let data = {
            'amount':(this.refundDetail.amount*100).toFixed(0),
            'device':this.phone,
            'mchId':this.mchId,
            'orderId':this.refundDetail.orderId,
            'desc':this.textarea
          }
          console.log(data);
          this.refundDetail.remark = this.textarea;
          this.dialogFormVisible = false;
          tradeDataOrder(data).then(res => {
            console.log(res);
            if(res.data.msg == 'success') {
              this.refundSuccDetail = res.data.data;
              this.Sactive = false;
              this.Wactive = true;
              this.inputVal = '';
              this.textarea = '';
              setTimeout(() => {
                this.refundSuccess = true;
              },300);
            } else {
              this.$message({
                message: res.data.msg
              });
            }
            
          })
        } else {
          this.$message({
            message: '请重新输入正确的金额'
          });
        }
        
      } 
    },
    // 校验输入框格式
    isMoney (money) {
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (reg.test(money)) {
        return true
      } else {
        return false
      }
    },
    _getPhone () {
      const ua = window.navigator.userAgent
        if (ua.search(/iphone/i) != -1) {
          this.phone = 'iphone'
        } else if (ua.search(/android/i) != -1 || ua.search(/linux/i) != -1) {
          this.phone = 'android'
        } else {
          this.phone = 'other'
        }
    },
    tofix (val) {
      return toFloat(val)
    },
    getMyDate (str) {
      var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth() + 1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSen = oDate.getSeconds(),
        oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSen)//最后拼接时间  
      return oTime  
    },
    // 补0操作
    getzf (num) {
      if (parseInt(num) < 10) {
        num = '0' + num  
      }
      return num  
    },
    searchRecode (id) {
      refundRecord(id).then(res => {
        console.log(res)
        this.refundRecordDataRecord = res.data.data
        this.sum = res.data.sum
        this.recordNum = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tradeTable {
  // width: 100%;
  margin-top: 10px;
  margin: 0 20px;
}
.bgFa {
  background-color: #fafafa;
}
/deep/ .el-dialog__header {
    padding: 10px 20px;
    border-bottom:1px solid #E2E2E2;
    .el-dialog__headerbtn {
      position: absolute;
      top: 15px;
      right: 20px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
  }
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-button+.el-button {
  margin-left: 0px;
}

// 退款提示框样式
.bounced{
  box-sizing: border-box; 
  color:#323232;
  font-display: 'PingFang-SC-Medium';
  position: relative;
  padding-top: 20px;
  .amount{
    display: flex;
    font-size:18px;
    line-height:18px;
    padding:0 0 28px 0;
  }
  .userName{
    display: flex;
    font-size:14px;
    line-height:13px;
    padding:0 0 31px 0;
    .name{
      flex-basis: 50%;
    }
    .mothods{
      flex: 1;
    }
  }
  .payDate{
    display: flex;
    font-size:13px;
    line-height:12px;
    padding:0 0 31px 0;
    .date{
      flex-basis: 50%;
    }
    .number{
      flex: 1;
    }
  }
  .warn{
    color:#999;
    padding:0 0 31px 0;
    .text1{
      display: flex; 
      .icon{
        display: inline-block;
        width:14px;
        height:14px;
        background: url(../assets/images/warning.png) no-repeat;
        background-size:100%;
      }
      .text{
        flex:1;
        margin-left: 6px;
        font-size:13px;
        line-height: 14px;
      }
    }
    .text2{
      margin-top:5px;
      font-size:13px;
      line-height: 14px;
    } 
  }
  .refund{
    display: flex;
    font-size:13px;
    line-height:12px;
    padding:0 0 31px 0;
    .refundAmount{
      flex-basis: 40%;
    }
    .remainingAmount{
      flex-basis: 38%;
    }
    .serchRecord{
      flex: 1;
      color:#409EFF;
      cursor: pointer;
    }
    .refundColor{
      color:#FF3300;
    }
  }
  .error{
    font-family: 'MicrosoftYaHei';
    font-size: 13px;
    line-height: 12px;
    color:#FF3300;
    position: absolute;
    bottom:-25px;
    left:0;
  }
  
  .EnterRefundAmount{
    width:100%;
    height:auto;
    padding-bottom:10px;   
    .inputBox{
      position: relative;    
      .RefundInput{
        margin-right:0;
        /deep/ .el-form-item__label {
          text-align: right;
          vertical-align: middle;
          float: left;
          font-size: 13px;
          color: #606266;
          line-height: 40px;
          padding: 0 12px 0 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
      }
      .poundage{
        position: absolute;
        top:40px;
        left:60px;
        font-size: 13px;
        line-height: 12px;
        color:#FF3300;
        margin:10px 0 10px;
      }
    }
    .unit{
      font-size: 13px;
      height:40px;
      line-height: 40px;
      text-align: cneter;
    }
    .button{
      .fullRefund{
        border:1px solid #fff;
        color:#409EFF;
      }
    }
  }
  .btm{
    margin-bottom:0;
     /deep/ .el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 12px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
     }
  }
  .form-button{
    display: block;
    margin:0 auto;
    margin-top:20px;
    .form-submit{
      display: block;
      margin:0 auto;
      width:140px;
      height:38px;
      background:#30CF7F;
      border-color:#30CF7F;
    }
  }
  .form-button :hover{
    background: #30CF71;
  }
}
.hidden{display:none !important;}

// 退款成功提示框样式
.detailsRefund{
  height:auto;
  .successLogo{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .icon{
      flex-basis: 40px;
      width:40px;
      height:40px;
      background:url(../assets/images/succ.png) no-repeat;
      background-size: 100%;
    }
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .waitingLogo{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .icon{
      flex-basis: 40px;
      width:40px;
      height:40px;
      background:url(../assets/images/wait.png) no-repeat;
      background-size: 100%;
    }
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .userName{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .name{
      flex-basis: 50%;
    }
    .money{
      flex: 1;
    }
  }
  .refundMothod{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .mothod{
      flex-basis: 50%;
    }
    .proson{
      flex: 1;
    }
  }
  .refundDate{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .refundTime{
      flex-basis: 50%;
    }
    .arriveTime{
      flex: 1;
    }
  }
  .orderId{
    display: flex;
    font-size:12px;
    line-height:12px;
    padding:0 0 31px 0;
    .text{
      flex-basis: 50%;
    }
  }
  .refundNote{
    display: flex;
    font-size:12px;
    line-height:16px;
    padding:0 0 31px 0;
    .refundNoteName{
      flex-basis: 64px;
    }
    .refundNoteText{
      flex: 1;
    }
  }
  .succ{
    display:none;
  }
  .wucc{
    display:none;
  }
}
// 退款详情提示框样式
.record{
  height:auto;
  .total{
    width:100%;
    height:40px;
    display: flex;
    // padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
    }
    .oldOrderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 100%;
        .font{
          cursor: pointer;
          color:#409EFF;
          margin-left:20px;
        }
      }
    }
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding:0 20px 10px;
}
// 退款记录提示框样式
.recordes{ 
  .top{
    width:100%;
    height:40px;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    border-bottom:1px solid #eee;
    .topOne{
      flex-basis: 30%;
    }
    .topTwo{
      flex: 1;
    }
    .color{
      color:#f00;
    }
  }
  .total{
    width:100%;
    height:40px;
    display: flex;
    padding-bottom:39px;
    .text{
      flex: 1;
      margin-left:14px;
      .textname{
        display:block;
        font-size:18px;
        line-height: 25px;
        color:#323232;
        .textDetail{
          display:block;
          font-size:12px;
          line-height: 12px;
          color:#999;
        }
      }
    }
  }
  .dataList{
    width:100%;
    height:auto;
    border-bottom:1px solid #eee;
    .userName{
      display: flex;
      font-size:12px;
      line-height:40px;
      .name{
        flex-basis: 35%;
      }
      .money{
        flex: 1;
      }
    }
    .refundMothod{
      display: flex;
      font-size:12px;
      line-height:40px;
      .mothod{
        flex-basis: 50%;
      }
      .proson{
        flex: 1;
      }
    }
    .refundDate{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundTime{
        flex-basis: 50%;
      }
      .arriveTime{
        flex: 1;
      }
    }
    .orderId{
      display: flex;
      font-size:12px;
      line-height:40px;
      .text{
        flex-basis: 50%;
      }
      .font{
        color: #409EFF;
        cursor: pointer;
      }
    }
    
    .refundNote{
      display: flex;
      font-size:12px;
      line-height:40px;
      .refundNoteName{
        flex-basis: 64px;
      }
      .refundNoteText{
        flex: 1;
      }
    }
  }
  .bottom{
    display: block;
    margin: 0 auto;
    margin-top:10px;
    .btn{
      display: block;
      margin: 0 auto;
      width: 140px;
      height: 38px;
      background: #30CF7F;
      border-color: #30CF7F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dinnerTable.vue